export default "__VITE_ASSET__2debd4a8__"